module.exports = __webpack_public_path__ + "static/media/FinancialPlanning.f29b106e.svg";